import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { forkJoin, Subscription } from 'rxjs';
import { LifestyleService } from 'src/app/services/ha-new/lifestyle.service';
import { SpinnerComponent } from 'src/app/modules/shared/spinner/spinner.component';
import { ActivatedRoute } from '@angular/router';
import { LookupService } from 'src/app/services/ha-new/lookup.service';
import { NewHAService } from 'src/app/services/ha-new/new-ha.service';

@Component({
	selector: 'app-health-goals',
	templateUrl: './health-goals.component.html',
	styleUrls: ['./health-goals.component.scss'],
})
export class HealthGoalsComponent implements OnInit {
	subscriptions: Subscription[] = [];
	/** holds ha id */
	healthAssessmentID: number = 0;
	/** holds appointment id */
	apptID: any;
	/** holds readOnly flag */
	readOnly: boolean = false;
	healthGoalsData: any = {};
	healthGoalsOptions: any = [];

	scrollTo = '';

	healthGoalsForm: FormGroup;

	disabled = false;
	max = 10;
	min = 1;
	step = 1;
	value = 0;

	tickInterval = 1;
	returningUser: boolean = false;

	constructor(
		private lifestyleService: LifestyleService,
		private spinner: SpinnerComponent,
		private activatedRoute: ActivatedRoute,
		private lookupService: LookupService,
		private haService: NewHAService
	) {
		this.activatedRoute.queryParams.subscribe(params => {
			//console.log('params:', params);
			this.apptID = params.apptID;
			this.readOnly = params.readOnly === 'true';
			this.healthAssessmentID = params.healthAssessmentID;
			this.returningUser = params.returningUser === 'true';
			if (this.scrollTo != 'false') {
				this.scrollTo = params.section;
			}
		});
	}

	ngOnInit() {
		this.getLookup();
		this.initializeHealthGoalsForm();
	}
	next() {
		if (!this.readOnly) {
			if (this.healthGoalsForm.valid) {
				this.saveHealthGoals();
			}
		}
	}

	getLookup() {
		this.spinner.startLoader();
		forkJoin({
			getHealthGoalsLookup: this.lookupService.getHealthGoalsLookup(),
			getHealthGoals: this.lifestyleService.getHealthGoals(this.apptID, this.healthAssessmentID),
		}).subscribe(
			res => {
				this.healthGoalsOptions = res.getHealthGoalsLookup.data;
				this.healthGoalsData = res.getHealthGoals.data;

				this.healthGoalsOptions.forEach(condition => {
					condition['checked'] = false;
				});

				this.healthGoalsForm.controls.otherGoalDescription.setValue(this.healthGoalsData.otherGoalDescription);
				this.healthGoalsForm.controls.healthMindedLifestyleImportance.setValue(
					this.healthGoalsData.healthMindedLifestyleImportance
				);

				if (!this.healthGoalsData.healthGoalPlanResponses) {
					this.healthGoalsData.healthGoalPlanResponses = [];
				}
				this.healthGoalsData.healthGoalPlanResponses.forEach(element => {
					this.healthGoalsOptions.find(e => {
						return e.id === element.optionID;
					})['checked'] = true;
				});

				this.spinner.stopLoader();

				if (this.scrollTo != 'false') {
					if (this.haService.scrollView(this.scrollTo)) {
						this.scrollTo = 'false';
					}
				}
			},
			err => {
				this.spinner.stopLoader();
				console.error(`[${HealthGoalsComponent.name}][${this.getLookup.name}]`, 'Error when getting sleep lookup data ', err);
			}
		);
	}
	healthGoalsSelection(condition) {
		//console.log(condition);
		condition.checked = !condition.checked;
		const index = this.healthGoalsData.healthGoalPlanResponses.findIndex(x => x.optionID == condition.id);
		if (condition.checked) {
			if (index == -1)
				this.healthGoalsData.healthGoalPlanResponses.push({
					optionID: condition.id,
				});
		} else {
			this.healthGoalsData.healthGoalPlanResponses.splice(index, 1);
		}
	}

	/**
	 * saves safety
	 */
	saveHealthGoals() {
		if (this.healthGoalsData.healthGoalPlanResponses) {
			const index = this.healthGoalsData.healthGoalPlanResponses.findIndex(x => x.optionID == 9);
			if (index == -1) {
				this.healthGoalsForm.controls.otherGoalDescription.setValue('');
			}
		}
		const formData = this.healthGoalsForm.getRawValue();
		// Prepopulated value if available and the value has not been updated
		if (this.returningUser || (!this.returningUser && this.selectionMade('healthMindedLifestyleImportance'))) {
			// formData.healthMindedLifestyleImportance = formData.healthMindedLifestyleImportance;
		} else if (this.healthGoalsData.healthMindedLifestyleImportance) {
			formData.healthMindedLifestyleImportance = this.healthGoalsData.healthMindedLifestyleImportance;
		} else {
			formData.healthMindedLifestyleImportance = undefined;
		}
		this.spinner.startLoader();
		this.subscriptions.push(
			this.lifestyleService
				.saveHealthGoals(this.apptID, {
					...formData,
					healthAssessmentID: this.healthGoalsData.healthAssessmentID,
					healthGoalPlanResponses: this.healthGoalsData.healthGoalPlanResponses,
				})
				.subscribe(
					res => {
						this.spinner.stopLoader();
						//console.log(res);
						this.haService.redirect(
							[],
							[],
							['how-you-eat'],
							this.apptID,
							this.healthAssessmentID,
							this.readOnly,
							'lifestyle-how-you-eat',
							this.returningUser
						);
					},
					err => {
						this.spinner.stopLoader();
						console.log(err);
					}
				)
		);
	}

	initializeHealthGoalsForm() {
		this.healthGoalsForm = new FormGroup({
			otherGoalDescription: new FormControl(''),
			healthMindedLifestyleImportance: new FormControl(''),
		});
	}

	selectionMade(slider) {
		return this.healthGoalsForm.get(slider).touched;
	}
}
